function EditIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_385_15340)">
                <path
                    d="M6.40951 2.54541H2.51315C2.2179 2.54541 1.93474 2.6627 1.72596 2.87147C1.51719 3.08025 1.3999 3.36341 1.3999 3.65866V11.4514C1.3999 11.7466 1.51719 12.0298 1.72596 12.2386C1.93474 12.4473 2.2179 12.5646 2.51315 12.5646H10.3059C10.6011 12.5646 10.8843 12.4473 11.0931 12.2386C11.3018 12.0298 11.4191 11.7466 11.4191 11.4514V7.55502"
                    stroke="currentColor"
                    strokeWidth="1.33587"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.5843 1.7101C10.8057 1.48866 11.1061 1.36426 11.4192 1.36426C11.7324 1.36426 12.0327 1.48866 12.2542 1.7101C12.4756 1.93154 12.6 2.23187 12.6 2.54503C12.6 2.8582 12.4756 3.15853 12.2542 3.37997L6.96624 8.66789L4.73975 9.22452L5.29637 6.99802L10.5843 1.7101Z"
                    stroke="currentColor"
                    strokeWidth="1.33587"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_385_15340">
                    <rect width="14" height="14" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default EditIcon;
